module.exports = __webpack_public_path__ + "img/fulllogo.77e740c5.svg";